import { useMemo } from 'react';
import { useIsDemo } from '@/hooks/common/useIsDemo';
import { useSelectedOrgId } from '@/hooks/common/useSelectedOrgId';
import { DEAL_PAGE_DATA, PERSONAL_ORG_ID } from '@/mockData';

export function useDealPageData() {
  const isDemo = useIsDemo();
  const selectedOrgId = useSelectedOrgId();
  const activeDealPageData =
    DEAL_PAGE_DATA[selectedOrgId] ?? DEAL_PAGE_DATA[PERSONAL_ORG_ID];

  const dealSummary = useMemo(
    () =>
      isDemo
        ? activeDealPageData.summary
        : {
            description: '',
            startDate: '',
            targetClose: '',
            dealValue: '',
            dealType: '',
            territory: '',
            duration: '',
            daysElapsed: 0,
            totalDays: 0,
            progressPercent: 0,
            albumCount: 0,
            royaltySplit: '',
            advancePercent: 0,
          },
    [activeDealPageData.summary, isDemo],
  );
  const keyTermChartData = useMemo(
    () => (isDemo ? activeDealPageData.chartData : {}),
    [activeDealPageData.chartData, isDemo],
  );
  const exampleActivity = useMemo(
    () => (isDemo ? activeDealPageData.activity : []),
    [activeDealPageData.activity, isDemo],
  );
  const documentVersions = useMemo(
    () => (isDemo ? activeDealPageData.documentVersions : []),
    [activeDealPageData.documentVersions, isDemo],
  );
  const keyDealTerms = useMemo(
    () => (isDemo ? activeDealPageData.keyTerms : []),
    [activeDealPageData.keyTerms, isDemo],
  );
  const dealBreakdown = useMemo(
    () => (isDemo ? activeDealPageData.breakdown : []),
    [activeDealPageData.breakdown, isDemo],
  );

  return {
    dealSummary,
    keyTermChartData,
    exampleActivity,
    documentVersions,
    keyDealTerms,
    dealBreakdown,
  };
}
